import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ModuleHeader, { ModuleHeaderAction } from "../../components/ModuleHeader/ModuleHeader";
import ModuleTable from "../../components/ModuleTable/ModuleTable";
import { listAdminUsers } from "../../api/adminUserApi";
import "../Module/module.scss";

const ADMIN_COLUMNS = ["Name", "Email", "Mobile", "Status", "Last Login", "Actions"];
const ADMIN_TEMPLATE = "repeat(6, minmax(140px, 1fr))";

const formatLastLogin = (value) => {
  if (!value) return "Never";

  return new Intl.DateTimeFormat("en-MY", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(new Date(value));
};

const AdministratorsPage = () => {
  const navigate = useNavigate();
  const [admins, setAdmins] = useState([]);
  const [status, setStatus] = useState("");
  const [keyword, setKeyword] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const timer = window.setTimeout(async () => {
      setIsLoading(true);
      setErrorMessage("");

      try {
        const result = await listAdminUsers({ status, keyword });
        setAdmins(result.data || []);
      } catch (error) {
        setErrorMessage(error.message);
      } finally {
        setIsLoading(false);
      }
    }, 250);

    return () => window.clearTimeout(timer);
  }, [status, keyword]);

  return (
    <div className="module-page">
      <ModuleHeader
        title="Administrators"
        description="Manage administrator accounts and platform access."
        actions={(
          <ModuleHeaderAction type="button" onClick={() => navigate("/administrators/create")}>
            + Add Administrator
          </ModuleHeaderAction>
        )}
      />

      <section className="module-page__filters">
        <label>
          <span>Status</span>
          <select value={status} onChange={(event) => setStatus(event.target.value)}>
            <option value="">All Status</option>
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
        </label>
        <label>
          <span>Keyword</span>
          <input
            type="search"
            placeholder="Search name or email..."
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
          />
        </label>
        <div />
      </section>

      <ModuleTable
        title="Administrators Listing"
        columns={ADMIN_COLUMNS}
        columnTemplate={ADMIN_TEMPLATE}
        variant="administrators"
        empty={
          errorMessage
            || (!isLoading && admins.length === 0 ? "No administrators found." : null)
        }
      >
        {admins.map((admin) => (
          <ModuleTable.Row key={admin.id} columnTemplate={ADMIN_TEMPLATE}>
            <span>{admin.name}</span>
            <span>{admin.email}</span>
            <span>{admin.phone || "—"}</span>
            <ModuleTable.Status value={admin.status ? "Active" : "Inactive"}>
              {admin.status ? "Active" : "Inactive"}
            </ModuleTable.Status>
            <span>{formatLastLogin(admin.last_logged_in)}</span>
            <span>
              <ModuleTable.Action to={`/administrators/${admin.id}/edit`}>
                Edit
              </ModuleTable.Action>
            </span>
          </ModuleTable.Row>
        ))}
      </ModuleTable>
    </div>
  );
};

export default AdministratorsPage;
